export { default } from './WidgetEmbedModal';
export { default as reducer } from './WidgetEmbedModal.ducks';
export { default as sagas } from './WidgetEmbedModal.sagas';

import * as actions from './WidgetEmbedModal.ducks';
export { actions };

